import { Component, createContext } from "react";

export const IdentityContext = createContext(null);

export const withIdentity = (WrappedComponent) => {
  class ComponentWithIdentity extends Component {
    render() {
      return (
        <IdentityContext.Consumer>
          {identity => <WrappedComponent {...this.props} identity={identity} />}
        </IdentityContext.Consumer>
      );
    }
  }

  ComponentWithIdentity.displayName = `withIdentity(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

  return ComponentWithIdentity;
};
